import api from '@/services/api';
import type { Department, DepartmentInput } from '@/types/department_schema';

const BASE_URL = '/university/departments';

export const departmentApi = {
  /**
   * Get all departments
   */
  getAllDepartments: async (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    faculty_id?: string;
    is_active?: boolean;
  }) => {
    return api.get<{ data: Department[]; meta?: any }>(BASE_URL, { params });
  },

  /**
   * Get departments by faculty
   */
  getDepartmentsByFaculty: async (facultyId: string) => {
    return api.get<{ data: Department[] }>(`/university/faculties/${facultyId}/departments`);
  },

  /**
   * Get a single department by ID
   */
  getDepartmentById: async (id: string) => {
    return api.get<{ data: Department }>(`${BASE_URL}/${id}`);
  },

  /**
   * Create a new department
   */
  createDepartment: async (input: DepartmentInput) => {
    return api.post<{ data: Department }>(BASE_URL, input);
  },

  /**
   * Update an existing department
   */
  updateDepartment: async (id: string, input: Partial<DepartmentInput>) => {
    return api.put<{ data: Department }>(`${BASE_URL}/${id}`, input);
  },

  /**
   * Delete a department
   */
  deleteDepartment: async (id: string) => {
    return api.delete(`${BASE_URL}/${id}`);
  },
};

export default departmentApi;
